// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".seo-content__text[data-v-7e2ac24d]{max-width:1150px}.seo-content__mayor[data-v-7e2ac24d]{line-height:1.3em}.seo-content__greeting[data-v-7e2ac24d]{position:relative}.seo-content__greeting-logo[data-v-7e2ac24d]{position:absolute;right:0;top:30px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
